import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import { doctoralRequests } from "api/doctoralApi";

const seats = `${DoctoralServicePath}doctoral-seats`;

export const STAGES = {
  fc: {
    key: "fc",
    label: "Чакащи ФС",
    resource: `${seats}/pending-fc-approval`,
    approveUrl: doctoralRequests.approveSeatsByFc(),
    declineUrl: doctoralRequests.declineSeatsByFc(),
    permission: permissions.canApproveDoctoralSeatsByFc,
  },
  ac: {
    key: "ac",
    label: "Чакащи АС",
    resource: `${seats}/pending-ac-approval`,
    approveUrl: doctoralRequests.approveSeatsByAc(),
    declineUrl: doctoralRequests.declineSeatsByAc(),
    permission: permissions.canApproveDoctoralSeatsByAc,
  },
  mon: {
    key: "mon",
    label: "Чакащи МОН",
    resource: `${seats}/pending-mon-approval`,
    approveUrl: doctoralRequests.approveSeatsByMon(),
    declineUrl: doctoralRequests.declineSeatsByMon(),
    permission: permissions.canApproveDoctoralSeatsByMon,
  },
};

export const STAGE_ORDER = ["fc", "ac", "mon"];
